import { WbTrapFocus } from './WbTrapFocus';

class WbInteractiveModule {
  constructor() {
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;

    document.querySelector('body')._addCustomEventListener('click', '.js-open-module', _this.openModule.bind(_this));

    document.querySelector('body')._addCustomEventListener('click', '.js-start-module', _this.start.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener(
        'change',
        '.wb-publication-interactive-module__options__input',
        _this.selectOption.bind(_this)
      );

    document
      .querySelector('body')
      ._addCustomEventListener(
        'change',
        '.wb-publication-interactive-module__selection-option__input',
        _this.selectOption.bind(_this)
      );

    document.querySelector('body')._addCustomEventListener('click', '.js-continue-module', _this.goToNext.bind(_this));

    document.querySelector('body')._addCustomEventListener('click', '.js-prev-module', _this.goToPrev.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-publication-interactive-module__close', _this.closeModule.bind(_this));

    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
  }

  toggleAjaxOverlay() {
    const overlayIsActive = document.querySelector('body').classList.contains('load-overlay');

    if (!overlayIsActive) {
      const icon = document.createElement('div');
      icon.classList.add('load-overlay__icon');

      document.querySelector('body').classList.add('load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.load-overlay').classList.remove('load-overlay');
      document.querySelector('.load-overlay__icon').remove();
    }
  }

  keydownEventListener(e) {
    const overlay = document.querySelector('#wb-publication-quiz');
    const isOpen = overlay?.classList.contains('wb-overlay--open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        this.closeModule();
        break;
    }
  }

  openModule(e) {
    const target = e.targetElement;
    const publication_id = target.getAttribute('data-publication-id');

    this.refTrigger = e.targetElement;
    this.fetchModule(`action=get_publications_module&publication_id=${publication_id}`).then(() => {
      const overlay = document.querySelector('.wb-overlay');

      this.WbTrapFocus = new WbTrapFocus({
        ele: overlay,
        activeClass: 'wb-overlay--open',
      });

      overlay.querySelector('.js-start-module').focus();
    });

    document.querySelector('html, body').classList.add('wb-overlay--active');
  }

  closeModule() {
    const overlay = document.querySelector('.wb-overlay');

    overlay._hide(0.5).then(() => overlay.remove());

    this.refTrigger.focus();
    this.refTrigger = false;

    document.querySelector('html, body').classList.remove('wb-overlay--active');
  }

  fetchModule(body, modalIsOpen = false) {
    const _this = this;

    this.toggleAjaxOverlay();

    return new Promise((resolve, reject) => {
      fetch(ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body,
      })
        .then((response) => {
          if (!response.ok) {
            this.toggleAjaxOverlay();
            reject(response.statusText);
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.text())
        .then((data) => {
          const PARSER = new DOMParser();
          const DOC = PARSER.parseFromString(data, 'text/html');
          const module = DOC.querySelector('.wb-publication-interactive-module');
          const inner = DOC.querySelector('.wb-publication-interactive-module__inner');

          if (modalIsOpen) {
            document.querySelector('.wb-publication-interactive-module__section').innerHTML = '';
            document.querySelector('.wb-publication-interactive-module__section')._appendAll(inner);
          } else if (module) {
            document.querySelector('body').appendChild(module);
            module._show(0.5);
            module.classList.add('wb-overlay--open');
          }

          _this.toggleAjaxOverlay();
          resolve();
        })
        .catch((error) => console.error(error));
    });
  }

  start(e) {
    const target = e.targetElement;
    const moduleId = target.getAttribute('data-id');

    this.fetchModule(`action=get_interactive-module_question&module_id=${moduleId}`, true);
  }

  goToPrev(e) {
    const target = e.targetElement;
    const id = target?.getAttribute('data-id');

    if (target.classList.contains('wb-publication-quiz__button--selection')) {
      this.start(e);
    } else if (id) {
      this.fetchModule(`action=get_interactive-module_question&module_id=${id}`, true);
    }
  }

  goToNext(e) {
    const target = e.targetElement;
    const option = target
      .closest('.wb-publication-interactive-module')
      .querySelector('[data-option]:checked')
      ?.getAttribute('data-option');

    if (option) {
      this.fetchModule(`action=get_interactive-module_question&module_id=${option}`, true);
    }
  }

  selectOption(e) {
    const target = e.targetElement;
    const option = target.getAttribute('data-option');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const modifier = isMobile ? '.--mobile' : '.--desktop';

    document.querySelectorAll(`[data-linked-option`)?.forEach((option) => {
      if (window.getComputedStyle(option).display != 'none') option._hide(0);
    });
    document.querySelector(`[data-linked-option="${option}"]${modifier}`)?._show(0);

    document.querySelector('.js-continue-module').disabled = false;
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.WbInteractiveModule = new WbInteractiveModule();
  }
});
